import { availableDarkThemes, saveUserTheme } from '@/utils/themesUtils'
import { moduleActionContext } from '@/vuex'
import { defineActions, defineGetters, defineModule, defineMutations } from 'direct-vuex'

export const themesActionContext = (context: any) => moduleActionContext(context, themesModule)

export interface ThemesState {
  themeName: string
}

const themesModule = defineModule({
  namespaced: true,
  state: {
    themeName: '',
  } as ThemesState,

  getters: defineGetters<ThemesState>()({
    isDarkTheme(state: ThemesState) {
      return availableDarkThemes.includes(state.themeName) || state.themeName === 'Iris Dark'
    },
  }),

  mutations: defineMutations<ThemesState>()({
    SET_THEME(state: ThemesState, theme: string) {
      state.themeName = theme
    },
  }),

  actions: defineActions({
    SAVE_USER_THEME(ctx, theme: string) {
      const { commit } = themesActionContext(ctx)
      commit.SET_THEME(theme)
      saveUserTheme(theme)
    },

    GET_USER_THEME(ctx) {
      const { commit } = themesActionContext(ctx)
      const theme: string | null = localStorage.getItem('iris_user_theme')
      if (theme) {
        commit.SET_THEME(theme)
      }
    },
  }),
})

export default themesModule
